import { Tag } from "../../hooks/react-query/outbound/freightDetails/useGetShipmentTags";

export const shipmentTagsResponse = {
  default: [
    {
      id: 3,
      color: "#EA5E5A",
      name: "CC",
      description: "Critical care shipment ",
    },
    {
      id: 2,
      color: "#FBC02D",
      name: "UC",
      description: "Urgent care shipment",
    },
    {
      id: 4,
      color: "#777DE9",
      name: "APTR",
      description: "Appointment Required ",
    },
    {
      id: 82,
      color: "#3664A2",
      name: "RSHP",
      description: "Reship",
    },
    {
      id: 84,
      color: "#9E393B",
      name: "LQ",
      description: "Limited Quantity",
    },
    {
      id: 5,
      color: "#69ADA8",
      name: "APTM",
      description: "Appointment Made",
    },
    {
      id: 81,
      color: "#AA7EA0",
      name: "VC",
      description: "Vendor Compliance",
    },
    {
      id: 79,
      color: "#B39DDB",
      name: "VOL",
      description: "Volume Shipment",
    },
    {
      id: 8,
      color: "#E280B4",
      name: "LM",
      description: "Large Mark - 6 plts or greater-6,000 lbs or greater",
    },
    {
      id: 75,
      color: "#C77563",
      name: "OVL",
      description: "Overlength",
    },
  ],
} as const satisfies Record<string, Tag[]>;
